import React from "react";
import Header from "../component/header";
import "../stylesheets/home.css";

const About = () => {
  return (
    <div>
      <Header />
      <div
        className="about-me-container"
        style={{ backgroundImage: `url(./aboutme.svg)` }}
      >
        <div className="about-me-section">
          <h1>Im Alzubair</h1>
          <p>
            I’m a Full-stack developer, I prefer Front-end side I know how to
            work with Html5, css3, JavaScript React, Redux, API, i used to work
            with express.js also. for the Backend i use Ruby and Rails, I use
            SQL database and Mongo Database. I Have a master’s degree in
            Information Technology- Computer Science
          </p>
        </div>
      </div>
    </div>
  );
};

export default About;
